import { useCallback, useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { Stack, Typography } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchaseOrderOrderTypeEnum } from "@/features/purchase-orders";
import {
  GeneralProductSection,
  LensProductSection,
  TransactionInformationSection,
} from "@/features/sales-requests";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading } from "@/features/ui";

export const SalesRequest = () => {
  const { referenceNumber } = useParams();
  const { outlet } = useAuth();
  const [loading, setLoading] = useState(true);
  const [salesRequest, setSalesRequest] = useState(null);
  const [error, setError] = useState(null);

  const loadSalesRequest = useCallback(async () => {
    if (!outlet) return;

    setLoading(true);
    setError(null);
    try {
      const {
        data: { data },
      } = await apiOutletClient.get(`sales-requests/${referenceNumber}`, {
        params: {
          withBuyer: true,
          withSeller: true,
          withCreator: true,
          withPurchaseOrder: true,
          withPurchaseOrderProductVariants: true,
          withSalesRequestProductVariants: true,
        },
      });
      setSalesRequest(data);
    } catch (error) {
      setError(
        getErrorMessage(error, "Gagal memuat permintaan penjualan")
      );
    } finally {
      setLoading(false);
    }
  }, [outlet, referenceNumber]);

  useEffect(() => {
    loadSalesRequest();
  }, [loadSalesRequest]);

  if (loading) {
    return <CenteredLoading sx={{ height: "100vh" }} />;
  }

  if (error) {
    return (
      <Typography variant="h6" color="error">
        {error}
      </Typography>
    );
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Permintaan Penjualan"
      breadcrumbs={[
        { title: "Permintaan Penjualan", path: "/sales/sales-requests" },
        { title: referenceNumber },
      ]}
    >
      <Stack spacing={2}>
        <TransactionInformationSection salesRequest={salesRequest} />
        {salesRequest.purchaseOrder.orderType ==
        PurchaseOrderOrderTypeEnum.STANDARD ? (
          <GeneralProductSection
            salesRequestProductVariants={
              salesRequest.salesRequestProductVariants
            }
          />
        ) : (
          <LensProductSection
            note={salesRequest.purchaseOrder.note}
            salesRequestProductVariants={
              salesRequest.salesRequestProductVariants
            }
          />
        )}
      </Stack>
    </PageContainer>
  );
};
